import React from "react";
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  tone?: "light" | "dark";
};
export function SectionHeading({
  eyebrow,
  title,
  tone = "light"
}: SectionHeadingProps) {
  const dark = tone === "dark";
  return <div className="mx-auto max-w-3xl text-center" data-id="element-251" data-mp="3f2wxvnuzz3xr">
      <p className={`text-sm font-extrabold uppercase tracking-wider ${dark ? "text-gold" : "text-brand"}`} data-id="element-252" data-mp="3jzneccaps1jp">
        {eyebrow}
      </p>
      <h2 className={`mt-3 font-display text-[2rem] font-black leading-[1.08] tracking-tight sm:text-5xl ${dark ? "text-white" : "text-navy"}`} data-id="element-253" data-mp="bkvkz0aob30q">
        {title}
      </h2>
    </div>;
}